export default __webpack_public_path__ + "static/smp-6823f2b6dfb70e2ebee095513b0745b9.webp";